module.exports = __webpack_public_path__ + "img/sigh@2x.d470ba5e.png";